module.exports = __webpack_public_path__ + "img/blank_card.359834f8.png";